// src/utils/AppRoute.js
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { TokenService } from '../api/tokenService';

const AppRoute = ({
  component: Component,
  layout: Layout,
  isPrivate,          // 👈 new flag to mark protected routes
  ...rest
}) => {
  const ResolvedLayout =
    Layout === undefined
      ? (props) => <React.Fragment>{props.children}</React.Fragment>
      : Layout;

  return (
    <Route
      {...rest}
      render={(props) => {
        // 🔒 if route is private and no access token → send to login
        if (isPrivate && !TokenService.getAccessToken()) {
          return <Redirect to="/login" />;
        }

        return (
          <ResolvedLayout {...rest}>
            <Component {...props} />
          </ResolvedLayout>
        );
      }}
    />
  );
};

export default AppRoute;
